// extracted by mini-css-extract-plugin
export default {"armondBlack":"#000000","armondWhite":"#FFFFFF","estimate":"home_estimate_estimate__HCe3b","info":"home_estimate_info__o-VB7","estimateBtn":"home_estimate_estimateBtn__D3E+4"};